// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"226":"3b1123af","250":"b82f5097","304":"acc7843c"}[chunkId] + ".css";
};